import React,{Fragment, useEffect, useState} from 'react';
import ReactPlayer from "react-player";
import Slider from 'react-slick';
import { getVideoData } from '../../../../api/salespro';
import { PARTNER_VIDEO_IDS, PARTNER_VIDEO_INFO } from '../../constants/salespro_webpage';
import Image from '../../../../components/common/Image';
import styles from './partnerVideos.module.scss';
import slick_styles from '../../../../styles/modules/ui-components/carosel.module.scss';
import { cleverTapTrigger } from '../../../../tracking/segment';
import { NextArrow, PrevArrow } from '../../../../components/common/ui-components/carosel';
import Config from '../../../../config';

const PartnerVideos = (props) => {
    const [videoData, setVideoData] = useState<any>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [videoClicked, setVideoClicked] = useState(false)
    const [isMobile, setMobile] = useState(false)
    const [isLarge, setLarge] = useState(false)
    const [video, setVideo] = useState('')

    useEffect(() => {
        window.innerWidth < 992 ? setMobile(true) : setMobile(false)
    });

    useEffect(() => {
        window.innerWidth < 1650 ? setLarge(true) : setLarge(false)
    });
    
    const handleBeforeChange = (oldIndex, newIndex) => {
        if(oldIndex != newIndex){
            setVideoClicked(false)
            setCurrentIndex(newIndex)
        }
      };

    useEffect (() => {
        if(props.video == 'partner') {
            props.setVideoPlaying(videoClicked)
        }
    }, [videoClicked])
      
    const settings = {
        centerMode: true,
        infinite: true,
        centerPadding: '28px',
        slidesToShow: 3,
        speed: 500,
        focusOnSelect: true,
        nextArrow: <NextArrow customStyle={{'top':'35%','right':'1%'}}/>,
        prevArrow: <PrevArrow customStyle={{'top':'35%','left':'1%'}}/>,
        autoplay: true,
        autoplaySpeed: 30000,
        beforeChange: handleBeforeChange
    };

    const partnerVideoClicked = (videoURL) => {
        setVideoClicked(true)
        props.setVideo('partner')
        cleverTapTrigger("Partner Videos Clicked", {'Video URL' : videoURL})
        setVideo(videoURL)
    }

    useEffect(()=>{
        const params = {
            key: Config.GOOGLE_MAP_KEY,
            id: PARTNER_VIDEO_IDS.join(','),
            part: ['snippet', 'status', 'statistics'].join(','),
          };
        getVideoData(params).then((res: any)=>{
            let data = res.data?.items
            for(let i=0;i<data.length;i++){
                data[i]['name'] = PARTNER_VIDEO_INFO[i].name
                data[i]['partner'] = PARTNER_VIDEO_INFO[i].partner
                data[i]['region'] = PARTNER_VIDEO_INFO[i].region
            }
            setVideoData(data)
        }).catch((err:any)=>{
            console.log("err: ", err)
        })
    },[])
    
    return (
    <Fragment>
        <div className={`${styles.parent_container} app-section`}>
            <div className={`app-section__title em ${styles.playlist_heading}`}>Hear From Our Partners</div>
            { props.video=='partner' && videoClicked &&
                <div className={styles.video}>
                    <ReactPlayer
                        id='partner_video'
                        url={video}
                        height={isLarge?'85%':'100%'}
                        width='480'
                        playing={props.videoPlaying}
                        onPause={() => {
                            props.setVideoPlaying(false)
                        }}
                    />
                </div>
            }
            <Slider {...settings} className={`${styles.video_carousel} ${slick_styles.slick_slider}`}>
                {videoData && videoData?.map((video, index) => (
                        index == currentIndex && video? (
                        <div key={video.id} className={styles.video_card}>
                        {props.video=='partner' && videoClicked?(
                                <div className={styles.thumbnail}>
                                </div>)
                            :(
                                <div className={styles.thumbnail} onClick={() => {partnerVideoClicked(('https://www.youtube.com/watch?v=' + video.id))}}>
                                    <Image src={video.snippet.thumbnails.maxres.url} alt={video.snippet.title} height="240" width="480"/>
                                    <div className={styles.play_button} >
                                        <Image src={('/static/images/salespro/play_button.svg')} alt='play' height='70' width='70' />
                                    </div>
                                </div>
                            )
                        }
                            <p className={styles.name}>{video.name}</p>
                            <p className={styles.details}>{video.partner} | {video.region}</p>
                        </div>):
                        (
                            <div key={video.id} className={styles.video_thumbnail}>
                                <Image src={video.snippet.thumbnails.maxres.url} alt={video.snippet.title} height={isMobile?'110px':'120vh'} width={isMobile?'220px':'240vw'}/>
                            </div>
                        )
                ))}
            </Slider>
        </div>
    </Fragment>
    );
}

export default PartnerVideos;
